import React, { createContext, useCallback, useContext, useState } from "react";

const I18nContext = createContext(null);

const dict = {
  ru: {
    nav: { about: "О себе", services: "Услуги", portfolio: "Портфолио", contact: "Контакты", admin: "Админ" },
    hero: {
      badge: "AI-CREATOR / GUANGZHOU · CHINA",
      title: "AI-Creator & Art Director",
      sub: "Создание премиального визуального контента, 3D-арта и генеративных AI-решений для брендов по всему миру.",
      cta1: "Обсудить проект",
      cta2: "Смотреть кейсы",
      stats: [
        { v: "4.6%", l: "CTR Ozon кейс" },
        { v: "21", l: "Возраст" },
        { v: "50+", l: "AI и 3D проектов" },
        { v: "China → World", l: "Логистика + Нейросети" },
      ],
    },
    about: {
      title: "О себе",
      p1: "Артём, 21 год. Живу в Гуанчжоу, Китай.",
      p2: "Соединяю физическую коммерцию Китая и передовые генеративные нейросети. Создаю коммерческую графику высокого чека, увеличиваю конверсию маркетплейсов и веду арт-направление брендов.",
      skills: "Стек и инструменты",
    },
    services: { title: "Услуги", sub: "Прайс от базовой карточки до полного ретейнера" },
    portfolio: { title: "Портфолио", sub: "Отобранные кейсы 2024–2026" },
    contact: {
      title: "Свяжитесь со мной",
      sub: "Расскажите о задаче — вернусь в течение 24 часов.",
      name: "Имя",
      email: "Email",
      project: "Тип проекта",
      budget: "Бюджет",
      message: "Сообщение",
      submit: "Отправить заявку",
      sent: "Заявка отправлена. Скоро свяжусь!",
      err: "Не удалось отправить. Попробуйте ещё раз.",
      types: ["Ozon / WB", "3D логотип", "Гейм-арт", "Сайт / лендинг", "Ретейнер", "Другое"],
    },
    admin: {
      title: "Вход в панель",
      username: "Логин",
      password: "Пароль",
      submit: "Войти",
      twofaTitle: "Двухфакторная аутентификация",
      twofaSetup: "Привяжите приложение-аутентификатор",
      twofaSetupDesc: "Отсканируйте QR-код в Google Authenticator / Authy и введите 6-значный код.",
      twofaCode: "6-значный код",
      twofaVerify: "Подтвердить",
      ipTitle: "Новый IP-адрес",
      ipDesc: "Мы отправили код в ваш Telegram. Введите его ниже.",
      logout: "Выйти",
    },
  },
  en: {
    nav: { about: "About", services: "Services", portfolio: "Portfolio", contact: "Contact", admin: "Admin" },
    hero: {
      badge: "AI-CREATOR / GUANGZHOU · CHINA",
      title: "AI-Creator & Art Director",
      sub: "Premium visual content, 3D art and generative AI solutions for brands worldwide.",
      cta1: "Start a project",
      cta2: "View cases",
      stats: [
        { v: "4.6%", l: "Ozon CTR case" },
        { v: "21", l: "Y.O." },
        { v: "50+", l: "AI & 3D projects" },
        { v: "China → World", l: "Logistics + Neural" },
      ],
    },
    about: {
      title: "About",
      p1: "Artem, 21. Based in Guangzhou, China.",
      p2: "I bridge China's physical commerce with cutting-edge generative networks. Commercial graphics, marketplace conversion and brand art direction.",
      skills: "Stack & tools",
    },
    services: { title: "Services", sub: "From a single product card to a full retainer" },
    portfolio: { title: "Portfolio", sub: "Selected cases 2024–2026" },
    contact: {
      title: "Get in touch",
      sub: "Tell me about your project — I reply within 24 hours.",
      name: "Name", email: "Email", project: "Project type", budget: "Budget", message: "Message",
      submit: "Send request", sent: "Sent! I'll be in touch soon.", err: "Failed to send, please retry.",
      types: ["Ozon / WB", "3D Logo", "Game Art", "Website", "Retainer", "Other"],
    },
    admin: {
      title: "Admin login",
      username: "Username", password: "Password", submit: "Log in",
      twofaTitle: "Two-factor authentication",
      twofaSetup: "Link an authenticator app",
      twofaSetupDesc: "Scan the QR in Google Authenticator / Authy and enter the 6-digit code.",
      twofaCode: "6-digit code",
      twofaVerify: "Verify",
      ipTitle: "New IP detected",
      ipDesc: "We sent a code to your Telegram. Enter it below.",
      logout: "Log out",
    },
  },
  cn: {
    nav: { about: "关于", services: "服务", portfolio: "作品", contact: "联系", admin: "后台" },
    hero: {
      badge: "AI 创作者 / 广州 · 中国",
      title: "AI 创作者 & 艺术总监",
      sub: "为全球品牌提供顶级视觉内容、3D 艺术与生成式 AI 解决方案。",
      cta1: "开始合作",
      cta2: "查看案例",
      stats: [
        { v: "4.6%", l: "Ozon CTR" },
        { v: "21", l: "岁" },
        { v: "50+", l: "AI 与 3D 项目" },
        { v: "China → 全球", l: "物流 + 神经网络" },
      ],
    },
    about: {
      title: "关于我",
      p1: "Artem，21 岁，常驻广州。",
      p2: "连接中国实体商业与前沿生成式神经网络。承接高客单商用图形、电商转化优化与品牌艺术指导。",
      skills: "技术栈",
    },
    services: { title: "服务", sub: "从单张商品图到全案月费" },
    portfolio: { title: "作品集", sub: "精选案例 2024–2026" },
    contact: {
      title: "联系我",
      sub: "告诉我你的需求，24 小时内回复。",
      name: "姓名", email: "邮箱", project: "项目类型", budget: "预算", message: "留言",
      submit: "提交", sent: "已发送！我会尽快联系。", err: "发送失败，请重试。",
      types: ["Ozon / WB", "3D Logo", "游戏原画", "网站", "月费服务", "其他"],
    },
    admin: {
      title: "后台登录", username: "账号", password: "密码", submit: "登录",
      twofaTitle: "双重认证",
      twofaSetup: "绑定验证器 App",
      twofaSetupDesc: "在 Google Authenticator / Authy 扫描二维码，输入 6 位验证码。",
      twofaCode: "6 位验证码", twofaVerify: "验证",
      ipTitle: "检测到新 IP",
      ipDesc: "我们已把验证码发到你的 Telegram，请在下方输入。",
      logout: "退出",
    },
  },
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "ru");
  const setLang = useCallback((l) => { localStorage.setItem("lang", l); setLangState(l); }, []);
  const applyDefault = useCallback((l) => { if (!localStorage.getItem("lang") && dict[l]) setLangState(l); }, []);
  const t = dict[lang];
  return <I18nContext.Provider value={{ lang, setLang, applyDefault, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
